import request from '@/utils/request'

/**
 * 获取系统配置列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含系统配置列表的Promise对象
 */
export function listSystemInfo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.listSystemInfo',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新系统配置
 * @param {Object} data 更新数据
 * @returns {Promise} 包含更新结果的Promise对象
 */
export function updateSystemInfo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.updateSystemInfo',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取物业URL
 * @returns {string} 物业URL
 */
export function getPropertyUrl() {
  let systemInfo = localStorage.getItem('java110SystemInfo')
  if (systemInfo) {
    systemInfo = JSON.parse(systemInfo)
    return systemInfo.propertyUrl
  }
  return ''
}

// 上传文件
export function uploadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/upload/uploadFile',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
        resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}